import { ClaimResponseType, UserType } from '../redux/actions/types'

export const checkCommentPermissions = (
  userRole: string,
  currentClaim: ClaimResponseType,
  user: UserType,
): boolean => {
  if (
    userRole === 'superAdmin' ||
    userRole === 'admin' ||
    userRole === 'directorPlace' ||
    userRole === 'employeePlace' ||
    userRole === 'directorAgent'
  ) {
    return true
  }

  if (userRole === 'employeeAgent') {
    const foundObject = currentClaim?.user?.employee?.company?.employees.find(
      (item) => item.id === user.employee?.id,
    )
    return !!foundObject
  }

  return false
}
